// app/report/report.js

(function () {
    'use strict';
    var controllerId = 'reportSuper';
    angular.module('app').controller(controllerId, ['$rootScope', '$filter', 'datacontext', 'common', 'sectionMenu', '_', 'moment', 'bootstrap.dialog', '$uibModal', reportSuperFn]);

    function reportSuperFn($rootScope, $filter, datacontext, common, sectionMenu, _, moment, bDialog, $uibModal) {
        var getLogFn = common.logger.getLogFn;
        var log = getLogFn(controllerId);
        var logError = getLogFn(controllerId, 'logError');
        var logSuccess = getLogFn(controllerId, 'logSuccess');
        var detectIE = $rootScope.detectIE;
        $rootScope.dashview = ""; // Azzera la classe dashview utile solo nelle dashboard 

        var vm = this;
        vm.title = 'Esporta dati'
        vm.sectionMenu = sectionMenu.setSection('Report');
        vm.loading == false;

        //Liste
        vm.list = {};
        vm.list.anni = [];
        //vm.list.mesi = [];
        //vm.list.giorni = [];
        //vm.list.setttimane = [];
        vm.list.aziende = [];

        // Filtro
        vm.filter = {};
        vm.filter.anno = vm.fAnno = 0;
        //vm.filter.mese = vm.fMese = 0;
        //vm.filter.giorno = vm.fGiorno = 0;
        //vm.filter.settimana = vm.fSettimana = 0;
        //vm.filter.dipendente = vm.fDipendente = -1; 
        //vm.filter.dataInizio = vm.fDataInizio = '';
        //vm.filter.dataFine = vm.fDataFine = '';
        //vm.filter.commessa = vm.fCommessa = '';
        vm.filter.azienda = vm.fAzienda = '';

        //Metodi su interfaccia
        vm.reportDipendenti = reportDipendenti;

        //Configurazione calendario
        vm.dateOptions = {
            formatYear: 'yy',
            startingDay: 1
        };
        vm.format = 'dd/MM/yyyy';

        vm.open = function ($event) {
            $event.preventDefault();
            $event.stopPropagation();

            vm.opened = !vm.opened;
            vm.opened1 = false;
        };

        vm.open1 = function ($event) {
            $event.preventDefault();
            $event.stopPropagation();

            vm.opened1 = !vm.opened1;
            vm.opened = false;
        };

        // ---- ACTIVATE -------
        activate();

        function activate() {
            vm.loading = true;
            var promises = [getListAnni(), getListAziende()];
            common.activateController(promises, controllerId).then(function () {
                var d = new Date();
                vm.fAnno = d.getFullYear();    
                vm.loading = false;
            });
        }

        //****************************************************
        // METODI 
        //****************************************************        
        function setFilter() {            
            vm.filter.anno = vm.fAnno == null ? 0 : vm.fAnno;
            vm.filter.azienda = vm.fAzienda == null ? '' : vm.fAzienda;
        }

        function reportDipendenti(bPDF) {
            setFilter();

            if (vm.loading == true)
                return;

            if (!vm.filter.anno) {
                logError('Indicare anno');
                return;
            }

            vm.loading = true;
            datacontext.report_getDipendenti(bPDF, vm.filter.anno, vm.filter.azienda).then(function (data) {
                if (data && data.url) {
                    var a = document.createElement("a");
                    var data_type = 'data:application/vnd.ms-excel,';
                    a.setAttribute('style', 'display:none');
                    a.setAttribute("target", "_blank");
                    if (bPDF) 
                        var data_type = 'data:application/pdf';

                    document.body.appendChild(a);
                    a.href = data.url;
                    a.download = data.file;
                    a.click();
                    document.body.removeChild(a);
                }
                else
                    logError('Impossibile scaricare il file');

                vm.loading = false;
            });
        }


        function getListAnni() {
            vm.list.anni = [];
            var item = {
                'Id': 0,
                'Name': '--Tutti--'
            };
            vm.list.anni.push(item);

            for (var i = 0; i < 90; i++) {
                var item = {
                    'Id': 2010 + i,
                    'Name': String(2010 + i)
                };
                vm.list.anni.push(item);
            }

            vm.filter.anno = vm.fAnno = new Date().getFullYear();
        }

        function getListMesi() {
            vm.list.mesi = [
                { 'Id': 0, 'Name': '--Tutti--' },
                { 'Id': 1, 'Name': 'Gennaio' },
                { 'Id': 2, 'Name': 'Febbraio' },
                { 'Id': 3, 'Name': 'Marzo' },
                { 'Id': 4, 'Name': 'Aprile' },
                { 'Id': 5, 'Name': 'Maggio' },
                { 'Id': 6, 'Name': 'Giugno' },
                { 'Id': 7, 'Name': 'Luglio' },
                { 'Id': 8, 'Name': 'Agosto' },
                { 'Id': 9, 'Name': 'Settembre' },
                { 'Id': 10, 'Name': 'Ottobre' },
                { 'Id': 11, 'Name': 'Novembre' },
                { 'Id': 12, 'Name': 'Dicembre' }
            ];

            vm.filter.mese = vm.fMese = new Date().getMonth() + 1;            
            meseChanged();
        }

        function getListSettimane() {
            vm.list.settimane = [];
            var item = {
                'Id': 0,
                'Name': '--Tutte--'
            };
            vm.list.settimane.push(item);

            for (var i = 1; i < 55; i++) {
                var item = {
                    'Id': i,
                    'Name': String(i)
                };
                vm.list.settimane.push(item);
            }
        }

        function getListGiorni() {
            vm.list.giorni = [];
            var item = {
                'Id': 0,
                'Name': '--Tutti--'
            };
            vm.list.giorni.push(item);

            for (var i = 1; i < 32; i++) {
                var item = {
                    'Id': i,
                    'Name': String(i)
                };
                vm.list.giorni.push(item);
            }
        }

        function getListSettimane() {
            vm.list.settimane = [];
            var item = {
                'Id': 0,
                'Name': '--Tutte--'
            };
            vm.list.settimane.push(item);

            for (var i = 1; i < 55; i++) {
                var item = {
                    'Id': i,
                    'Name': String(i)
                };
                vm.list.settimane.push(item);
            }
        }

        function meseChanged() {
            switch (vm.fMese) {
                case 1:
                    vm.strMese = 'Gennaio';
                    break;
                case 2:
                    vm.strMese = 'Febbraio';
                    break;
                case 3:
                    vm.strMese = 'Marzo';
                    break;
                case 4:
                    vm.strMese = 'Aprile';
                    break;
                case 5:
                    vm.strMese = 'Maggio';
                    break;
                case 6:
                    vm.strMese = 'Giugno';
                    break;
                case 7:
                    vm.strMese = 'Luglio';
                    break;
                case 8:
                    vm.strMese = 'Agosto';
                    break;
                case 9:
                    vm.strMese = 'Settembre';
                    break;
                case 10:
                    vm.strMese = 'Ottobre';
                    break;
                case 11:
                    vm.strMese = 'Novembre';
                    break;
                case 12:
                    vm.strMese = 'Dicembre';
                    break;
            }
        }


        function getListAziende() {
            return datacontext.azienda_getAllList().then(function (data) {
                return vm.list.aziende = data;
            });
        }

    }
})();